import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    loaded: false,
    showMSOAuthButton: false,
    hasTrinFormLicense: false,
    trinFormUrl: ""
  }
};
const AppSlice = createSlice({
  name: "appInfo",
  initialState,
  reducers: {
    load: (state, action) => {
      state.value = {
        loaded: false,
        showMSOAuthButton: action.payload.showMSOAuthButton,
        hasTrinFormLicense: action.payload.hasTrinFormsLicense,
        trinFormUrl: action.payload.trinFormsUrl,
        currentTDVersion: action.payload.currentTDVersion
      };
    }
  }
});
export const { load } = AppSlice.actions;
export default AppSlice.reducer;
